import { mobileFilters } from '../const/mobile-headers-const';

export const chunkArrayToPages = (arr, size) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
    arr.slice(i * size, i * size + size),
  );

export const objToArray = (item) => Object.entries(item);

export const roundTo2Dec = (number) => Math.round(number * 100) / 100;

export const isHeaderDefined = (reportName) => mobileFilters.some(({ name }) => name === reportName);

export const excludeAccordion = (item, reportName) => item.filter(x => !excludeHeaders(item, reportName).includes(x));

export const excludeHeaders = (item, reportName) => {
  const { headers } = mobileFilters.find(({ name }) => name === reportName) || {};
  return isHeaderDefined(reportName) ? item.filter(([key]) => headers?.includes(key)) : [item[0]];
};